// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"6ba21602","342":"9413387d","519":"e7018e32","862":"c95985df","922":"ef04ec04","923":"34556a8c","985":"18c14813"}[chunkId] + ".chunk.js";
};